// https://mui.com/customization/spacing/

const spacing = 6

export default spacing
